/**
 * @Description 首页接口
 */

import { get, post } from '@/common/request/index';


/**
 * 当前菜单列表
 * https://yapi.lanhanba.com/project/469/interface/api/52492
 */
export function getUserMenu() {
  return get(`/v2/user/menu/list`, {}, {
    isMock: false,
    mockId: 469,
    needHint: true,
    isTerra: true,
    needCancel: false
  });
}

/**
 * 审批列表-https://yapi.lanhanba.com/project/532/interface/api/55579
 */
export function approvalList(params: any) {
  return post('/v2/approval/list', { ...params }, {
    isMock: false,
    mockId: 532,
    needHint: true,
    isTerra: true,
    needCancel: false
  });
}


/**
 * 拓店任务数据看板
 * https://yapi.lanhanba.com/project/532/interface/api/67899
 */

export function getTaskOverView(params?: any) {
  return get('/v2/standard/task/overview', { ...params }, {
    isMock: false,
    mockId: 532,
    needHint: true
  });
}



/**
 * 机会点数据看板
 * https://yapi.lanhanba.com/project/532/interface/api/67920
 */
export function getChancePointOverView(params?: any) {
  return get('/v2/standard/chancePoint/overview', { ...params }, {
    isMock: false,
    mockId: 532,
    needHint: true
  });
}



/**
 * 加盟商数据看板
 * https://yapi.lanhanba.com/project/532/interface/api/67927
 */
export function getFranchiseeOverView(params?: any) {
  return get('/v2/standard/franchisee/overview', { ...params }, {
    isMock: false,
    mockId: 532,
    needHint: true
  });
}

/**
 * 集客点数据看板
 * https://yapi.lanhanba.com/project/546/interface/api/81717
 */
export function getGatheringPointOverView(params?: any) {
  return post('/v2/plan/spot/overview', { ...params }, {
    isMock: false,
    mockId: 532,
    needHint: true
  });
}

/**
 * 选址地图周边查询
 * https://yapi.lanhanba.com/project/546/interface/api/67969
 */
export function getModelClusterSurround(params?: any) {
  return get('/v2/modelCluster/surroundInfo', { ...params }, {
    isMock: false,
    mockId: 546,
    needHint: false
  });
}

/**
 * 踩点宝首页统计
 * https://yapi.lanhanba.com/project/329/interface/api/69635
 */
export function getCheckSpotProjectStatistics(params?: any) {
  return post('/v2/checkSpot/project/statistics', { ...params }, {
    isMock: false,
    mockId: 329,
    needHint: false
  });
}

/**
 * 踩点宝首页-踩点任务分页查询(租户端)
 * https://yapi.lanhanba.com/project/329/interface/api/69656
 */
export function getCheckSpotProjectList(params?: any) {
  return post('/v2/checkSpot/project/home/pages', { ...params }, {
    isMock: false,
    mockId: 329,
    needHint: false
  });
}
/**
 * 加盟商申请数据看板
 * https://yapi.lanhanba.com/project/532/interface/api/86799
 */
export function getFranchiseeClue(params?: any) {
  return get('/v2/franchiseApplication/overview', { ...params }, {
    isMock: false,
    mockId: 329,
    needHint: false
  });
}
/**
 * 周边信息-覆盖物
 * https://yapi.lanhanba.com/project/532/interface/api/86799
 */
export function getLogo(params?: any) {
  return get('/v2/modelCluster/surroundInfo/covering', params,);
}

/**
 * 首页搜索-清空全部历史记录
 * https://yapi.lanhanba.com/project/546/interface/api/88388
 */
export function postDeleteHistory(params?: any) {
  return get('/v2/user/search/removeAll', params,);
}

/**
 * 首页搜索-搜索历史&大家都在搜
 * https://yapi.lanhanba.com/project/546/interface/api/88386
 */
export function getHotSearcList(params?: any) {
  return get('/v2/user/search/queryList', params,);
}

/**
 * 首页搜索-搜索结果
 * https://yapi.lanhanba.com/project/546/interface/api/88980
 */
export function getSearchResult(params?: any) {
  return post('/v2/user/search/result', params,);
}
